import "../components/styles.css";
import React from "react";
import CalendarPicker from "../components/calendar-picker";
import VacationItem from "../components/vacation-item";
import Toggle from "../components/switch";
import HourglassBottomIcon from "@mui/icons-material/HourglassBottom";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import Time from "../components/time";

export default function DaysHalfAndHours({
  onSelectedDateFrom,
  dateFrom,
  onSelectedDateTo,
  dateTo,
  checked,
  onChecked,
  defaultAM,
  onHandleToggle,
  canSelectPast,
  is24HoursFormat,
  timeFrom,
  onSelectTimeFrom,
  isShowHours,
  onShowHoursChecked,
  timeTo,
  onSelectTimeTo,
  isMobile,
}) {
  return (
    <>
      <div
        className="check-in-out-container"
        id="days-half-and-hours-from-container"
      >
        <CalendarPicker
          label={"From"}
          isStanAlone
          onSelected={(value, str) => onSelectedDateFrom(value, str)}
          value={dateFrom}
          isDisablePast={!canSelectPast}
          id="days-half-and-hours-calendar-from-component"
        />
        {checked && (
          <Toggle
            defaultAM={defaultAM}
            onHandleToggle={onHandleToggle}
            id="days-half-and-hours-toggle-half-day-component"
          />
        )}
        {isShowHours && (
          <Time
            label={"Time"}
            ampm={!is24HoursFormat}
            value={timeFrom}
            onChange={(value) => onSelectTimeFrom?.(value)}
            id="days-half-and-hours-time-from-component"
          />
        )}
      </div>
      <div
        className="check-in-out-container"
        id="days-half-and-hours-to-container"
      >
        <CalendarPicker
          label={"To"}
          isStanAlone
          onSelected={(value, str) => onSelectedDateTo(value, str)}
          value={dateTo}
          isDisablePast={!canSelectPast}
          id="days-half-and-hours-calendar-to-component"
        />
        {isShowHours && (
          <Time
            label={"Time"}
            ampm={!is24HoursFormat}
            value={timeTo}
            onChange={(value) => onSelectTimeTo?.(value)}
            id="days-half-and-hours-time-to-component"
          />
        )}
        {checked && (
          <div
            className="empty"
            id="empty-view"
            style={{
              marginLeft: 20,
              marginRight: 20,
              width: isMobile ? 205 : 155,
            }}
          ></div>
        )}
      </div>
      <div className="toggle" id="days-half-and-hours-show-hours-container">
        <VacationItem
          checked={isShowHours}
          onChecked={onShowHoursChecked}
          title={"Show hours"}
          icon={AccessTimeIcon}
          color={"#35a3dc"}
          id="days-half-and-hours-show-hours-component"
        />
      </div>
      <div className="toggle" id="days-half-and-hours-half-day-container">
        <VacationItem
          checked={checked}
          onChecked={onChecked}
          title={"Half day"}
          icon={HourglassBottomIcon}
          color={"orange"}
          id="days-half-and-hours-half-day-component"
        />
      </div>
    </>
  );
}
